import * as React from "react";
const SvgFiRrHandBackPointRight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M9.721 22H5c-2.757 0-5-2.243-5-5v-6.969c0-2.137.832-4.146 2.343-5.657l2.308-2.308A3.61 3.61 0 0 1 7.224 1h.006a3.6 3.6 0 0 1 2.576 1.075l3.919 3.945L20.996 6a3 3 0 0 1 2.963 3.496c-.232 1.427-1.551 2.503-3.066 2.503H15.82l-1.196 5.981A5.014 5.014 0 0 1 9.721 22M7.225 3c-.438 0-.85.17-1.159.48L3.758 5.788a5.96 5.96 0 0 0-1.757 4.243V17c0 1.654 1.346 3 3 3h4.721a3.01 3.01 0 0 0 2.942-2.412l1.357-6.785a1 1 0 0 1 .98-.804h5.893c.537 0 1.017-.362 1.093-.825a1.002 1.002 0 0 0-.986-1.176l-13.997.039h-.003a1 1 0 0 1-.003-2l3.917-.011-2.527-2.544a1.63 1.63 0 0 0-1.161-.484h-.002z"
    />
  </svg>
);
export default SvgFiRrHandBackPointRight;
